module.exports = __webpack_public_path__ + "img/keyboard_E.e9181275.png";